import cn from 'classnames';
import { FC } from 'react';

import { MobileLayout } from '@/shared/ui';

import { MobileHeader } from '@/widgets/Header';

import styles from '../../Encounters.module.scss';
import { UseEncountersPageResult } from '../../hooks';
import { EncounterDetails } from '../EncounterDetails/EncounterDetails';

import { EncountersListPane } from './EncountersListPane';

type EncountersMobileLayoutProps = UseEncountersPageResult & {
  className?: string;
};

export const EncountersMobileLayout: FC<EncountersMobileLayoutProps> = (
  props,
) => {
  const {
    approveDocument,
    attachPatient,
    className,
    clearSelectedEncounter,
    fetchedEncounterError,
    fetchedEncounterLoading,
    scrollContainerRef,
    selectedEncounter,
    selectedEncounterId,
    ...listProps
  } = props;

  const isDetailsView = Boolean(selectedEncounterId);

  return (
    <MobileLayout>
      <MobileHeader
        showBackButton={isDetailsView}
        onBackButtonClick={clearSelectedEncounter}
      />
      <MobileLayout.Main>
        <div
          ref={scrollContainerRef}
          className={cn(styles.mobileWrapper, className)}
        >
          {isDetailsView ? (
            <div className={styles.mobileContent}>
              <EncounterDetails
                encounter={selectedEncounter}
                loading={fetchedEncounterLoading}
                error={fetchedEncounterError}
                onApproveDocument={approveDocument}
                onAttachPatient={attachPatient}
              />
            </div>
          ) : (
            <div className={styles.mobileList}>
              <EncountersListPane
                selectedEncounterId={selectedEncounterId}
                {...listProps}
              />
            </div>
          )}
        </div>
      </MobileLayout.Main>
    </MobileLayout>
  );
};
